// extracted by mini-css-extract-plugin
module.exports = {"contentPublicity":"publicity_contentPublicity_2FN5j","slice":"publicity_slice_2MKiR","clickable":"publicity_clickable_227jA","block":"publicity_block_1ZMw_"};